import { firestore } from '@/plugins/firebase'
import store from '@/store'

function fetch (params) {
  const url = this.getURL(this.getFetchRoute(), params)

  this.onFetch()

  let ref = firestore.collection(url)

  if (!params) {
    console.warn('fetch() argument cannot be null')
  }

  if (typeof params === 'object') {
    if (params.where) {
      for (let w of params.where) {
        ref = ref.where(...w)
      }
    }

    if (params.orderBy) {
      for (let o of params.orderBy) {
        ref = ref.orderBy(...o)
      }
    }

    if (params.limit) {
      ref = ref.limit(params.limit)
    }

    return new Promise((resolve, reject) => {
      ref.onSnapshot(
        (snapshot) => {
          this.onFetchSuccess(snapshot)
          resolve(snapshot)
        },
        (err) => {
          this.onFetchFailure()
          reject(err)
        })
    })
  } else {
    return new Promise((resolve, reject) => {
      ref.doc(params)
        .get()
        .then(doc => {
          this.onFetchSuccess(doc)
          resolve(doc)
        })
        .catch(err => {
          this.onFetchFailure()
          reject(err)
        })
    })
  }
}

async function save (params) {
  const collection = this.getURL(this.getSaveRoute(), params)

  try {
    await this.onSave()
  } catch (error) {
    store.commit('notifyError', { message: `Invalid ${this.getModelName()} data`, error })
    throw error
  }

  let ref = firestore.collection(collection)
  let data = this.getSaveData()

  if (this.autoFields) {
    const now = new Date().getTime()
    if (this.isNew()) {
      data.createdAt = now
      data.createdBy = store.getters['user/currentUid']
    }

    data.updatedAt = now
  }

  if (this.isNew()) {
    ref = ref.add(data)
  } else {
    ref = ref.doc(this.identifier())
      .update(data)
  }

  logFeed(
    this.isNew() ? 'created' : 'updated',
    this.getModelName().toLowerCase(),
    this.name)

  return ref
    .then(newRef => {
      if (newRef) { data.id = newRef.id }
      this.onSaveSuccess(data)
      store.commit('notify', `${this.getModelName()} successfully saved`)
    })
    .catch(error => {
      this.onSaveFailure(error)
      store.commit('notifyError', { message: `Can't save ${this.getModelName()}`, error })
    })
}

function _delete (params) {
  const collection = this.getURL(this.getDeleteRoute(), params)

  this.onDelete()

  return firestore.collection(collection)
    .doc(this.identifier())
    .delete()
    .then(() => {
      this.onDeleteSuccess()
      store.commit('notify', `${this.getModelName()} successfully deleted`)
    })
    .catch(error => {
      this.onDeleteFailure()
      store.commit('notifyError', { message: `Can't delete ${this.getModelName()}`, error })
    })
}

/**
 *  Luca  created  activity Align requirements 2 hours ago
 * | who | action | entity |       name       |    when   |
 */
function logFeed (action, entity, name, project) {
  firestore
    .collection('feed')
    .add({
      createdBy: store.getters['user/currentUid'],
      action,
      entity,
      name,
      when: new Date().getTime()
    })
}

export {
  fetch,
  save,
  _delete
}
